import React from 'react';
import JSZip from 'jszip';
import saveAs from 'file-saver';

import api from '../../utils/api';

class Export extends React.Component {

    apiCall = null;

    state = {
        pages: null,
        showIndividual: false
    };

    componentDidMount() {

        const { projectId } = this.props;

        this.apiCall = api.getProjectPages({ projectId })
            .then(({ data: pages }) => {

                this.setState({ pages });
            });

    }

    componentWillUnmount() {

        api.cancel(this.apiCall);
    }

    onClickExport = e => {

        const zip = new JSZip();

        return Promise.all(this.state.pages.map(fileName => {

            return api.getPage(fileName).then((page) => {

                zip.file(fileName, page);
            });
        }))
            .then(() => zip.generateAsync({type:'blob'}))
            .then(blob => saveAs(blob, `${this.props.projectId}.zip`));
    };

    onClickShowIndividual = e => {

        this.setState({ showIndividual: true });
    };

    get body() {

        let lis = [];
        let text = 'Loading...';
        let canExport = false;

        if (this.state.pages) {

            const numPages = this.state.pages.length;

            if (numPages === 0) {
                text = 'Nothing to export';
            }
            canExport = true;
            text = 'Export all';
            lis = this.state.pages.map(fileName => (
                <a
                    key={fileName}
                    target="_blank"
                    href={`https://storage.googleapis.com/total-comments.storage.commentbox.io/${fileName}?alt=media`}
                    download={fileName.split('/')[1]}
                    className="list-group-item"
                >
                    {fileName.split('/')[1]} <span className="glyphicon glyphicon-share-alt" />
                </a>
            ));
        }


        return (
            <div  style={{ textAlign: 'center' }}>

                <p className="text-muted">
                    Pick an option below to export your comments.
                </p>

                <div className="controls">

                    <div className="form-group">

                        <div className="row">

                            <div className="col-xs-6">
                                <button
                                    type="button"
                                    className="btn btn-default pull-right"
                                    disabled={!canExport}
                                    onClick={this.onClickExport}
                                >
                                    {text}
                                </button>

                            </div>

                            <div className="col-xs-6">

                                <button
                                    type="button"
                                    className="btn btn-default pull-left"
                                    disabled={!canExport}
                                    onClick={this.onClickShowIndividual}
                                >
                                    Show Files
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

                <div className="individual" style={this.state.showIndividual ? null : {display: 'none'}}>

                    <hr />

                    <div className="list-group">
                        {lis}
                    </div>

                </div>

            </div>
        );
    }

    render() {
        return (
            <div className="export">

                <div className="panel panel-default">
                    <div className="panel-body">

                        <fieldset>
                            <legend>
                                Export Published Comments <a target="_blank" href="https://commentbox.io/docs/dashboard#exporting-comments">Learn more <span className="glyphicon glyphicon-share-alt" /></a>
                            </legend>

                            <div className="row">
                                <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
                                    {this.body}
                                </div>
                            </div>

                        </fieldset>

                    </div>
                </div>


            </div>
        );
    }
}

export default Export;


// WEBPACK FOOTER //
// ./src/components/projects/Export.jsx